/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 10/8/13
 * Time: 11:45 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var Backbone = require('backbone');
    var _ = require("underscore");


    var GalleryModel = Backbone.Model.extend({
        defaults : {
            selectedOption:null,
            selectableGallery: true
        },
        hasSelectedOption: function() {
            return !_.isNull(this.get("selectedOption"));
        },
        isSelectableGallery: function() {
            return this.get("selectableGallery");
        }
    });

    return GalleryModel;
});
